import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import baseURL from '../component/baseURL';
import { ReactNotifications } from 'react-notifications-component';
import showNotification from '../component/Notification';

export default function Notifications() {
    const navigate = useNavigate();
    const { t } = useTranslation();


    const [notifications, setNotifications] = useState([]);
    const [loadData, setLoadData] = useState(false);
    const [notifCount, setNotifCount] = useState(0);
    const [userID, setUserID] = useState('');
    const [agentkey, setAgentkey] = useState('');
    const [agentID, setAgentID] = useState('');

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        setUserID(userid);
        const agentkey = localStorage.getItem('agentKey');
        setAgentkey(agentkey);
        const agentid = localStorage.getItem('agentID');
        setAgentID(agentid);


        fetchNotifications(userid);
    }, []);

    function fetchNotifications(userid) {
        setLoadData(false);
        console.log("USER ID: " + userid);
        let formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        //formdata.append("agent_key",this.state.agentKey)

        console.log(formdata);

        fetch(baseURL.URL + "/users/show_notifications", {
            method: "POST",
            body: formdata,
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                const result = responseJson.response.notifications;
                console.log(result[0])
                if (responseJson.server.result_code === 200) {
                    setNotifications(result);
                    setLoadData(true);
                    if (result && result.length > 0) {
                        setNotifCount(result.length);
                    }
                } else {
                    showNotification('Error', responseJson.server.message, 'danger');
                    setLoadData(true);
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while fetching notifications', 'danger');
                setLoadData(true);
            });
    }

    function readAllNotificationAPI() {
        let formdata = new FormData();
        formdata.append("user_id", userID);
        formdata.append("notification_id", "");
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        fetch(baseURL.URL + "/users/read_notifications", {
            method: "POST",
            body: formdata,
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (responseJson.server.result_code === 200) {
                    fetchNotifications(userID);
                    showNotification('Success', 'All notifications marked as read', 'success');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }


    function readSingleNotificationAPI(notifId, pushKey, listingId) {
        let formdata = new FormData();
        formdata.append("user_id", userID);
        formdata.append("notification_id", notifId);
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");

        console.log(formdata);

        fetch(baseURL.URL + "/users/read_notifications", {
            method: "POST",
            body: formdata,
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (responseJson.server.result_code === 200) {
                    showNotification('Success', 'Notification marked as read', 'success');
                    fetchNotifications(userID);
                    // navigate(pushKey, listingId)

                }
                else {
                    showNotification('Error', 'Something went wrong while marking notification as read', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    if (!loadData) {
        return (
            <div className="content-right page-loader-wrapper">
                <div className="react-js-loader">
                    <div className="react-js-loader-spinner"></div>
                    <p className="react-js-loader-text">Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* <!-- Desktop Notification Header --> */}
            <ReactNotifications />
            <div className="notification-page-header">
                <div className="container">
                    <div className="notification-header-content">
                        {/* <div className="notification-back-btn" aria-label="Back" onClick={() => window.history.back()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M12.5 15L7.5 10L12.5 5" stroke="#0E0E0E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div> */}
                        <h1 className="notification-page-title">Notifications</h1>
                        <button
                            type="button"
                            className="desktop-mark-all-read"
                            id="desktopMarkAllRead"
                            onClick={readAllNotificationAPI}
                        >
                            Mark all as read
                        </button>
                    </div>
                </div>
            </div>

            {/* <!-- Mobile Notification Header --> */}
            <header className="mobile-notification-header">
                {/* <div className="mobile-notification-back" aria-label="Back" onClick={() => window.history.back()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none">
                        <path d="M11.668 23.2341C11.4486 23.2354 11.2312 23.1933 11.0281 23.1104C10.8251 23.0274 10.6404 22.9052 10.4847 22.7508L0.484654 12.7508C0.174236 12.4385 0 12.0161 0 11.5758C0 11.1355 0.174236 10.713 0.484654 10.4008L10.4847 0.400762C10.8035 0.127718 11.2136 -0.014959 11.6331 0.00124297C12.0525 0.0174449 12.4504 0.191331 12.7473 0.488156C13.0441 0.78498 13.218 1.18288 13.2342 1.60234C13.2504 2.0218 13.1077 2.43193 12.8347 2.75076L4.01799 11.5674L12.8347 20.3841C13.0687 20.6162 13.2286 20.9125 13.2943 21.2355C13.3599 21.5586 13.3283 21.8938 13.2034 22.1989C13.0786 22.5039 12.866 22.7651 12.5927 22.9494C12.3194 23.1336 11.9976 23.2327 11.668 23.2341Z" fill="black" />
                    </svg>
                </div> */}
                <h1 className="mobile-notification-title">Notifications</h1>
                <a
                    href="#"
                    className="mobile-mark-all-read"
                    id="markAllRead"
                    onClick={(e) => {
                        e.preventDefault();
                        readAllNotificationAPI();
                    }}
                >
                    Mark all as read
                </a>
            </header>

            {/* <!-- Main Content --> */}
            <main className="main-content">
                <div className="container">
                    {/* <span className="notification-count">No. of notifications: {notifications.length}</span> */}
                    <div className="notification-list">
                        {/* <!-- Notification Card 1 - Unread --> */}
                        {notifications.length > 0 ? (
                            notifications.map((notification) => {
                                const sender = notification.sender_details || {};
                                const senderName = [sender.fname, sender.lname].filter(Boolean).join(' ').trim() || '—';
                                const senderImage = sender.profile_image ?? sender.profile_image ?? 'https://placehold.co/48x48';
                                const pushKey = notification.push_key || '—';
                                const date = notification?.added_date ? String(notification.added_date).replace(/\//g, '-') : '';
                                return (
                                    <div className={`notification-card ${notification.read_status === '0' ? 'unread' : 'read'}`} key={notification.notification_id || notification.id} onClick={() => readSingleNotificationAPI(notification.notification_id, pushKey, notification.listing_id)}>
                                        <div className="notification-icon">
                                            <div className="notification-icon-circle">
                                                <img src={senderImage} alt={senderName} />
                                                <div className="notification-dot"></div>
                                            </div>
                                        </div>
                                        <div className="notification-content">
                                            <h3 className="notification-title">{senderName}</h3>
                                            <p className="notification-description">{pushKey} <span className="notification-date">{date}</span></p>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="no-notification-message text-center">
                                <p>No notifications found</p>
                            </div>
                        )}

                    </div>
                </div>
            </main>
        </>
    );
}